module.exports = __webpack_public_path__ + "img/IMG_8629_T_FoamcoreMatted.662f3717.jpg";